module.exports = __webpack_public_path__ + "static/media/MusicDetailsScreen_elStartplayingCopy_488445.beb2193b.jpg";